import * as React from 'react'
import * as PropTypes from 'prop-types'
import { css } from 'glamor'

import { AnimateHeight } from '../animate-height'

interface IAnimateChildHeightProps {
  children: React.ReactNode
}

export class AnimateChildHeight extends React.PureComponent<IAnimateChildHeightProps> {
  static propTypes = {
    children: PropTypes.node,
  }

  constructor(props: IAnimateChildHeightProps) {
    super(props)

    this.contentRef = React.createRef()
  }

  state = { childHeight: 0 }

  componentDidMount() {
    if (!this.contentRef.current) {
      return
    }

    const childHeight = this.contentRef.current.offsetHeight
    if (this.props.children) {
      //eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ childHeight })
    }
  }

  componentDidUpdate() {
    if (!this.contentRef.current) {
      return
    }

    const childHeight = this.contentRef.current.offsetHeight
    if (this.props.children) {
      //eslint-disable-next-line react/no-did-update-set-state
      this.setState({ childHeight })
    }
  }

  contentRef: React.RefObject<HTMLDivElement>

  render() {
    const { children } = this.props

    return (
      <AnimateHeight height={children ? 'auto' : 0} innerRef={this.contentRef}>
        {children || <div {...css({ height: this.state.childHeight })} />}
      </AnimateHeight>
    )
  }
}
